import React, { Component } from "react";
import AchievementPopup from '../home/AchievementPopup';

class MarketplaceAchievements extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		openAchievementPopup: false,
		openedAchievement: {}
    }
	
}
 
componentDidMount(){
	
}

showAchievementPopup = (mod) =>{
	console.log(mod);
	let openedAchievement = mod;
	this.setState({
		openedAchievement: mod,
		openAchievementPopup: true,
	});
}

closeAchievementPopup = () =>{
	this.setState({openAchievementPopup: false});
}

  render() {
	 return (
		<div className="booked_pop_content zIndex5">
			<div className="bookmarked_content addWidth">
				<div className="close_pops"	onClick={() => this.props.updateStateFromChild({openAchievements: false})}></div>
				{ this.props.achievementType == 'recent' &&
					<div>
						<div className="achievementTitle">Recent Achievements</div>
						{ this.props.achieveDates.map((date, index) =>
							<div key={index}>
								<div className="achiDate">{date}</div>
									<div className="achieveCont">
										{ this.props.achieveData[date].map((item, i) =>
											<div className="oneAchieve" key={i} onClick={() => this.showAchievementPopup(item)}>
												<div className="achieveTroph"></div>
												<div className="achieveInfo">
													<div className="achieveVal">{item['value']}</div>
													<div className="achieveVal">{item['name']}</div>
												</div>
											</div>
										)}
									</div>
							</div>
						)}
					</div>
				}
				{ this.props.achievementType == 'monthly' &&
					<div>
						<div className="achievementTitle">Monthly Achievements</div>
						{ this.props.achieveDates.map((date, index) =>
							<div key={index}>
								<div className="achiDate">{date}</div>
									<div className="achieveCont">
										{ this.props.achieveData[date].map((item, i) =>
											<div className="oneAchieve" key={i} onClick={() => this.showAchievementPopup(item)}>
												<div className="achieveTroph"></div>
												<div className="achieveInfo">
													<div className="achieveVal">{item['value']}</div>
													<div className="achieveVal">{item['name']}</div>
												</div>
											</div>
										)}
									</div>
							</div>
						)}
					</div>
				}
			</div>
			{ this.state.openAchievementPopup &&
				<div className="inPopup">
					<AchievementPopup 
						closeAchievementPopup={this.closeAchievementPopup}
						openedAchievement = {this.state.openedAchievement}
					></AchievementPopup>
				</div>
			}
		</div>
    );
  }
}
export default MarketplaceAchievements;
